module.exports = __webpack_public_path__ + "img/empty_cart.fcf93f8c.svg";